import Icon from '../../../components/AppIcon';

const OptimalTimingRecommendations = ({ platform }) => {
  const recommendations = {
    facebook: [
      { day: 'Monday', time: '1:00 PM - 3:00 PM', engagement: 'High', reason: 'Lunch break browsing peak' },
      { day: 'Wednesday', time: '11:00 AM - 1:00 PM', engagement: 'High', reason: 'Mid-week engagement surge' },
      { day: 'Friday', time: '10:00 AM - 12:00 PM', engagement: 'Medium', reason: 'Weekend planning starts' }
    ],
    instagram: [
      { day: 'Tuesday', time: '11:00 AM - 2:00 PM', engagement: 'High', reason: 'Peak visual content consumption' },
      { day: 'Thursday', time: '5:00 PM - 6:00 PM', engagement: 'High', reason: 'After-work scrolling time' },
      { day: 'Sunday', time: '9:00 AM - 11:00 AM', engagement: 'Medium', reason: 'Weekend leisure browsing' }
    ],
    twitter: [
      { day: 'Monday', time: '8:00 AM - 10:00 AM', engagement: 'High', reason: 'Morning news consumption' },
      { day: 'Wednesday', time: '12:00 PM - 1:00 PM', engagement: 'High', reason: 'Lunch break updates' },
      { day: 'Friday', time: '5:00 PM - 6:00 PM', engagement: 'Medium', reason: 'End of workday engagement' }
    ],
    linkedin: [
      { day: 'Tuesday', time: '7:00 AM - 9:00 AM', engagement: 'High', reason: 'Professional morning routine' },
      { day: 'Wednesday', time: '12:00 PM - 1:00 PM', engagement: 'High', reason: 'Business lunch networking' },
      { day: 'Thursday', time: '5:00 PM - 6:00 PM', engagement: 'Medium', reason: 'End of business day' }
    ],
    tiktok: [
      { day: 'Tuesday', time: '6:00 PM - 9:00 PM', engagement: 'High', reason: 'Evening entertainment peak' },
      { day: 'Friday', time: '7:00 PM - 10:00 PM', engagement: 'High', reason: 'Weekend start celebration' },
      { day: 'Sunday', time: '2:00 PM - 5:00 PM', engagement: 'Medium', reason: 'Afternoon relaxation time' }
    ]
  };

  const platformData = recommendations?.[platform] || recommendations?.facebook;

  const getEngagementColor = (level) => {
    switch (level) {
      case 'High':
        return 'text-success';
      case 'Medium':
        return 'text-warning';
      default:
        return 'text-muted-foreground';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="TrendingUp" size={20} className="text-primary" />
        <h3 className="text-sm font-semibold text-foreground">
          Optimal Posting Times for {platform ? platform?.charAt(0)?.toUpperCase() + platform?.slice(1) : 'All Platforms'}
        </h3>
      </div>
      <div className="space-y-3">
        {platformData?.map((rec, index) => (
          <div key={index} className="flex items-start gap-3 p-3 bg-muted/50 rounded-lg">
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center">
              <Icon name="Clock" size={16} className="text-primary" />
            </div>
            <div className="flex-1">
              <div className="flex items-center justify-between mb-1">
                <span className="text-sm font-medium text-foreground">{rec?.day}</span>
                <span className={`text-xs font-semibold ${getEngagementColor(rec?.engagement)}`}>
                  {rec?.engagement} Engagement
                </span>
              </div>
              <p className="text-sm text-muted-foreground mb-1">{rec?.time}</p>
              <p className="text-xs text-muted-foreground">{rec?.reason}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-4 p-3 bg-accent/10 rounded-lg">
        <div className="flex items-start gap-2">
          <Icon name="Lightbulb" size={16} className="text-accent flex-shrink-0 mt-0.5" />
          <p className="text-xs text-accent">
            These recommendations are based on historical engagement data and may vary based on your specific audience demographics and behavior patterns.
          </p>
        </div>
      </div>
    </div>
  );
};

export default OptimalTimingRecommendations;